import { Box, Grid, IconButton, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { Constants } from "../../../../../../utils/constants"
import { DateModalRange, DateModalRangeRef } from "../../../../../../components/dinamicForm/dateModal"
import { createRef, useRef } from "react"
import { onChange } from "../../../../../../utils/types"
import dayjs from "dayjs"
import { toUnitTimeZone } from "../../../../../../utils/methods/calcDate"
import { FileUpload } from "../fileUpload"
import { Step1Props } from "./types"
import { CustomTable } from "../../../../../../components"
import { RefTable } from "../../../../../../components/table/types"
import { useContextState } from "../../../../../../hooks/theme"
import { icons } from "../../../../../../utils/icons"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { FiltersFloat } from "../../../../../logbook/pages/main/components/access/components/filtersFloat"


export const BasicConfiguration = ({ column, searchUsersSolicited, userFilter, inputUser, row, isLoading, data, errors, setData, setErrors, file, setFile }: Step1Props) => {

    const styles = useStyles()
    const { t } = useTranslation()
    const refRange = createRef<DateModalRangeRef>()
    const refTable = useRef<RefTable>(null)
    const { colors } = useContextState()
    const { cleanFilter, counter, errors: errorsFilter, filterData, onChange: onChangeFilter } = userFilter
    const onChange: onChange = ({ target }) => {
        const { name, value } = target
        let body = { ...data }
        body = {
            ...data,
            [name]: value,
        }

        if (['from', 'to'].includes(name)) {
            const from = name == 'from' ? value : data.from
            const to = name == 'to' ? value : data.to

            if (Boolean(to)) {
                let errorMessage = ''
                if (dayjs(to).isBefore(dayjs(from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
                if (dayjs(to).isBefore(dayjs(toUnitTimeZone(new Date(), Constants.defaultTimeZoneObject.value)).add(5, 'minute'))) { errorMessage = t('general.validations.minimusCurrentDay') }
                setErrors(prev => ({
                    ...prev,
                    to: errorMessage
                }))
            }
        }

        setData(prev => ({ ...prev, ...body }))
    }

    const handleCleanFilter = () => {
        cleanFilter()
        searchUsersSolicited({all:false})
    }

    return (
        <Box>
            <Typography sx={styles.title}>{t('filesManager.titles.basicConfiguration')}</Typography>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={8} xl={7}>
                    <FileUpload file={file} setFile={setFile} />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={4} xl={5}>
                    <Box sx={styles.containerDate}>
                        <DateModalRange
                            mimTimeZone={Constants.defaultTimeZoneObject}
                            defaultErrors={{ from: errors?.from, to: errors?.to }}
                            setDate={(payload) => {
                                onChange({
                                    target: {
                                        name: payload.target.name,
                                        value: payload.target.value,
                                    }
                                })
                            }}
                            from={data.from}
                            to={data.to ?? null}
                            ref={refRange}
                            titleFrom="Inicio de visualización"
                            titleTo="Fin de visualización"
                            minHeight={136}
                            clear
                        />
                    </Box>
                </Grid>
            </Grid>
            <Box sx={styles.headerTitle}>
                <Typography sx={styles.title}>{t('filesManager.titles.requestingUsers')}</Typography>

                <Box sx={styles.containerFilter}>
                    <Box sx={styles.drawerfilter}>
                        <FiltersFloat title={t('general.filterBy')} cleanFilter={handleCleanFilter} count={counter} right={-74} top={0} searchButton={{ disabled: false/* !userFilter.query?.filter */, loading: false, onClick: ()=>{ searchUsersSolicited({all:true}); } }}>
                            <DinamicForm input={Object.values(inputUser)} onChange={onChangeFilter} errors={errorsFilter} values={filterData} />
                        </FiltersFloat>
                    </Box>

                    <IconButton
                        sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
                        onClick={() => {
                            handleCleanFilter()
                        }}
                    >
                        {icons('clean')}
                    </IconButton>
                </Box>
            </Box>

            <CustomTable
                ref={refTable}
                loader={isLoading}
                dontRefresh
                column={column}
                row={row ?? []}
                color={colors}
                selected={-1}
                noContent={t('filesManager.messages.whitoutUsersYouCanAdd')}
                iconsNoContent={icons('userAccount')}
            />
        </Box>
    )
}